import React from "react";
import RegionLangHolder from "./Styles/regionLanguageStyle";
import { CircleFlag } from "react-circle-flags";
import { Row, Col, Button, Icon, Tooltip } from "antd";
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobeAmericas } from "@fortawesome/free-solid-svg-icons";

class RegionLanguageComponent extends React.Component{
    constructor(props){
        super(props);
        this.state = {
        }
    }

    render(){
        const {t,
               invoiceIssuingCountry ,
               billingCountry,
               currency,

               editCampaignActive,
               campaignInvoiceIssuingCountry,
               campaignCurrency,
               campaignBillingCountry,

               showModal,
               disabledButton
        } = this.props;

        const usedInvoiceIssuingCountry = editCampaignActive ? campaignInvoiceIssuingCountry : invoiceIssuingCountry
        const usedBillingCountry = editCampaignActive ? campaignBillingCountry : billingCountry
        const usedCurrency = editCampaignActive ? campaignCurrency : currency

        const invoiceIssuingCountryLower = usedInvoiceIssuingCountry ? usedInvoiceIssuingCountry.toLowerCase(): null
        const billingCountryTranslated = usedBillingCountry == 'Factura Internacional' ? t('International billing') : usedBillingCountry

        return (
          <RegionLangHolder>
            <Tooltip 
            placement="bottomLeft" 
            title={disabledButton ? t('Edition available on map') : null}
            >
              <Row type="flex" align="middle">
                <Col>
                  <Button
                    style={{
                      borderColor: "transparent",
                      backgroundColor: "transparent",
                    }}
                    size="small"
                    onClick={() => showModal()}
                    disabled={disabledButton}
                  >
                    <Icon type="global" />
                    {t('language iso 639-1')}
                  </Button>
                </Col>
                <Col>
                  <Button
                    style={{
                      borderColor: "transparent",
                      backgroundColor: "transparent",
                    }}
                    size="small"
                    onClick={() => showModal()}
                    disabled={disabledButton}
                  >
                    <div style={{ paddingBottom: "2px" }}>
                      {
                      billingCountryTranslated === "International billing" || billingCountryTranslated === "Factura Internacional" ? <FontAwesomeIcon icon={faGlobeAmericas} /> : <CircleFlag countryCode={invoiceIssuingCountryLower} height="16.5" width="14"/>
                      }
                    <span style={{ paddingLeft: "8px" }}>{billingCountryTranslated}</span>
                    </div>
                  </Button>
                </Col>
                <Col>
                  <Button
                    style={{
                      borderColor: "transparent",
                      backgroundColor: "transparent",
                    }}
                    size="small"
                    onClick={() => showModal()}
                    disabled={disabledButton}
                  >
                    <Icon type="dollar" />
                    {usedCurrency}
                  </Button>
                </Col>
              </Row>
            </Tooltip>
          </RegionLangHolder>
        );
    }
}

export default withTranslation()(RegionLanguageComponent);
